import React from "react";

// External
import styled from "@emotion/styled";

// Local
import { Content, colorScheme } from "../styled/styled";

// Data
import sources from "../data/sources.json";

const Li = styled.li`
  list-style: none;
`;

const Box = styled.div`
  margin: 0 0 96px 0;
`;

const Outro = () => {
  return (
    <Content
      style={{ color: colorScheme.neutralLightColor, listStyle: "none" }}
    >
      <Box>
        <p>
          It is hard to figure out the reason why some countries cluster
          together when they have no obvious relationships.
        </p>
        <p>
          Although in general, belonging to a regional or subregional group
          plays a major role in the chances of countries to have a common
          membership to an international organization. Economic and cultural
          similarities could also be another factor to form an alliance between
          countries.
        </p>
      </Box>
      <Box>
        <h2>Methodology</h2>
        <p>
          The data was scraped from the CIA World Factbook international
          organizations list. The information on each organizations and its
          respective member countries were extracted. We then count the number
          of memberships for every two country which has a common membership and
          stored it into a matrix. Some countries were not included due to
          insufficient data.
        </p>
        <p>
          <a href="https://lvdmaaten.github.io/tsne/">
            T-SNE (T-distributed stochastic neighbor embedding)
          </a>{" "}
          was the algorithm used to cluster countries according to which
          countries would more likely cluster together based on the matrix we
          produced.
        </p>
        <p>
          Countries were also projected on a tile grid view based on Maarten
          Lambrecht's work to see every country's relative position on a world
          map to avoid the difficulties of viewing smaller countries in terms of
          geographical area.
        </p>
      </Box>
      <Box>
        <h2>Credits</h2>
        <p>
          Created by Joseph Ricafort as a final internship project for{" "}
          <a href="https://interactivethings.com">Interactive Things</a>, a User
          Experience and Data Visualization Studio based in Zürich, Switzerland.
        </p>
        <p>
          Thank you very much to Luc for the guidance keeping me on track, to
          Peter for providing different perspectives to problem solving, to
          Cécile for the alternative solutions to tricky problems, to Tania for
          the constant design feedbacks, and also to everyone at Interactive
          Things for the overwhelming support.
        </p>
      </Box>
      <Box>
        <h2>Sources</h2>
        <h3>Data</h3>
        <ul>
          {sources
            .filter(src => src.type === "data")
            .map(src => (
              <Li>
                <strong>
                  <a href={src.link}>{src.source}</a>
                </strong>{" "}
                - {src.description}
              </Li>
            ))}
        </ul>
        <h3>Graphics</h3>
        <ul>
          {sources
            .filter(src => src.type === "asset")
            .map(src => (
              <Li>
                <strong>
                  <a href={src.link}>{src.source}</a>
                </strong>{" "}
                {src.description}
              </Li>
            ))}
        </ul>
        <h3>Inspiration</h3>
        <ul>
          {sources
            .filter(src => src.type === "inspiration")
            .map(src => (
              <Li>
                <strong>
                  <a href={src.link}>{src.source}</a>
                </strong>{" "}
                {src.description}
              </Li>
            ))}
        </ul>
      </Box>
    </Content>
  );
};

export default Outro;
